import styled from 'styled-components';
import { colorGrey400, fontFamilyRoboto, mediaQueryMobileLargeMin } from 'styleUtils';
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-avtrov-0"
})(["display:flex;margin:0 auto;width:100%;padding:", ";margin-bottom:12px;@media ", "{width:max-content;padding:", ";align-items:center;margin-bottom:", ";}"], function (_ref) {
  var isCompanyPage = _ref.isCompanyPage;
  return isCompanyPage ? '0' : '0 16px';
}, mediaQueryMobileLargeMin, function (_ref2) {
  var isCompanyPage = _ref2.isCompanyPage;
  return isCompanyPage ? '0 16px' : '0';
}, function (_ref3) {
  var isCompanyPage = _ref3.isCompanyPage;
  return isCompanyPage ? '0' : '12px';
});
export var UpdateText = /*#__PURE__*/styled.p.withConfig({
  componentId: "sc-avtrov-1"
})(["font-family:", ";font-style:normal;font-weight:500;font-size:11px;line-height:24px;display:flex;align-items:center;text-align:center;letter-spacing:1px;text-transform:uppercase;color:", ";margin-right:16px;"], fontFamilyRoboto, colorGrey400);